<div>
    <mat-card>
        <div class="col-12 justify-content-center">
            <app-data-table
                [dataSource]="claimsDataSource"
                [displayedColumns]="claimsColumns"
                [component]="'Property Claims'"
                (pageEvent)="onPageEvent($event)"
                (sortEvent)="onSortEvent($event)"
                [displayLoadingIndicator]="loading"
                [showSearch]="false"
                [tableLength]="claimsTableLength"
                [pageSize]="claimsPageSize"
                [navigateOnRowClick]="true"
                [getStatusColor]="getClaimStatusColor"
                [showPaginator]="true">
            </app-data-table>
        </div>
    </mat-card>
</div>